// extracted by mini-css-extract-plugin
export default {"line":"Footer_line__HB1EO","footerContent":"Footer_footerContent__GXdue","socialLinks":"Footer_socialLinks__lqtSQ"};